<template>
    <div class="calendar">
            <vue-hash-calendar 
            ref="picker"
            model="dialog"
            :visible.sync="isShowCalendar" 
            :disabled-date="disabledDate" 
            @click="dateClick" 
            format="YY-MM-DD"
            :scroll-change-date="true"
            :is-show-week-view="false"
            @confirm="dateConfirm"
            :showTodayButton = "isshow"
            >
            </vue-hash-calendar>
            <div class="cancel" @click="cancel">取消</div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      isShowCalendar: true,
      isShowCalendars: false,
      isshow: false,
      defaultDatetime: ""
    };
  },
  created() {
    //this.$router.go(0)
  },
  methods: {
    disabledDate(date) {},
    dateClick(date) {
      // 点击日期时按钮触发
      console.log(date, "click");
    },
    dateConfirm(date) {
      // 点击确认按钮触发
      console.log(date);
      if (this.$route.query.channel == 'Green') {
        sessionStorage.setItem("calendar", date);
        this.$router.push({
          path: "/hospital"
        });
      } else {
        sessionStorage.setItem("calendar2", date);
        this.$router.push({
          path: "/reserve"
        });
      }
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.cancel {
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 99999;
  color: #666;
  font-size: 13px;
  padding: 12px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/calendar.vue